// O lançamento de UM sinal, do toque no cartão do monitor.
//
// Pedido do Ilton (27/09): "quando eu clicar no marcador só deve aparecer
// aquele marcador para eu preencher" — a tela de medidas inteira, com nove
// campos, deixava digitar no campo errado. Aqui entra só o que o cartão mostra:
// um número (ou dois, na pressão). Sem React, para o teste rodar no Node.
import { FAIXA_PLAUSIVEL, type TipoLeitura } from '@medicov1/shared';

export interface CamposDoSinal {
  valor?: string;
  sistolica?: string;
  diastolica?: string;
}

export interface LeituraALancar { tipo: TipoLeitura; valor: number; grupo?: string }

export type Lancamento = { ok: true; leituras: LeituraALancar[] } | { ok: false; erro: string };

/** "36,8" -> 36.8; vazio ou lixo -> null. */
export function numeroDoCampo(bruto: string | undefined): number | null {
  const t = (bruto ?? '').replace(',', '.').trim();
  if (!t) return null;
  const n = Number(t);
  return Number.isFinite(n) ? n : null;
}

function dentroDoPossivel(tipo: TipoLeitura, valor: number, rotulo: string): string | null {
  const f = FAIXA_PLAUSIVEL[tipo];
  return valor < f.min || valor > f.max
    ? `${rotulo}: ${valor.toLocaleString('pt-BR')} está fora do possível (${f.min}–${f.max}). Confira o que digitou.`
    : null;
}

/**
 * Monta as leituras do lançamento, ou diz o que está errado. A pressão vira
 * duas leituras do mesmo evento, unidas pelo grupo — como vem do aparelho.
 */
export function montarLancamento(tipo: TipoLeitura, c: CamposDoSinal, rotulo: string, grupo: string): Lancamento {
  if (tipo === 'pa_sistolica' || tipo === 'pa_diastolica') {
    const sis = numeroDoCampo(c.sistolica);
    const dia = numeroDoCampo(c.diastolica);
    if (sis === null || dia === null) return { ok: false, erro: 'Pressão: preencha a máxima e a mínima.' };
    const fora = dentroDoPossivel('pa_sistolica', sis, 'Máxima') ?? dentroDoPossivel('pa_diastolica', dia, 'Mínima');
    if (fora) return { ok: false, erro: fora };
    if (sis <= dia) return { ok: false, erro: 'Pressão: a máxima tem de ser maior que a mínima. Não foram trocadas?' };
    return { ok: true, leituras: [{ tipo: 'pa_sistolica', valor: sis, grupo }, { tipo: 'pa_diastolica', valor: dia, grupo }] };
  }
  const v = numeroDoCampo(c.valor);
  if (v === null) return { ok: false, erro: `${rotulo}: digite o valor.` };
  const fora = dentroDoPossivel(tipo, v, rotulo);
  if (fora) return { ok: false, erro: fora };
  return { ok: true, leituras: [{ tipo, valor: v }] };
}
